import { Link } from 'react-router-dom';
import { checkoutPath } from '@/content/plans';

export function HomeHero({ appsCount, fromPrice }: { appsCount: number; fromPrice: string }) {
  return (
    <section className="hx-hero" id="topo">
      <div className="hx-hero-in">
        <div className="hx-hero-copy">
          <span className="hx-pill">
            <i />
            Provedor de Tecnologia verificado pela Meta
          </span>
          <h1>
            O WhatsApp oficial da sua empresa, <em>com os apps que a operação precisa.</em>
          </h1>
          <p className="hx-hero-lead">
            CRM, atendimento e funil de vendas no WhatsApp, com {appsCount} apps no mesmo login: Hub Comercial
            para marketplaces, CoreMed para clínicas, IA, agenda, PDV e estoque. Ative só o que usar.
          </p>
          <div className="hx-actions">
            <Link className="btn hx-btn-main" to={checkoutPath}>
              Assinar agora
            </Link>
            <a className="btn hx-btn-line" href="#apps">
              Ver os {appsCount} apps e preços
            </a>
          </div>
          <div className="hx-hero-facts">
            <span>
              A partir de <strong>{fromPrice}/mês</strong>
            </span>
            <span>Sem fidelidade</span>
            <span>Taxa da Meta sem markup</span>
          </div>
        </div>
        <div className="hx-hero-art">
          <picture>
            <source media="(max-width: 700px)" srcSet="/hero/hero-operax-960.webp" type="image/webp" />
            <img
              src="/hero/hero-operax.webp"
              alt="Operax: atendimento no WhatsApp oficial com IA, conectado ao Hub Comercial, CoreMed, funil de vendas, agenda, PDV e estoque e oficina"
              width={1448}
              height={1086}
              fetchPriority="high"
              decoding="async"
            />
          </picture>
        </div>
      </div>
      <div className="hx-hero-fade" />
    </section>
  );
}
